/**
 * Translation service for automatically translating text via external API
 */

const TRANSLATION_API_URL = "http://localhost:5000/translate";

export async function translate(
  text: string,
  sourceLanguage: string = "fr",
  targetLanguage: string = "en"
): Promise<string> {
  if (!text || text.trim() === "") {
    return text;
  }

  try {
    const response = await fetch(TRANSLATION_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        text: text,
        from: sourceLanguage,
        to: targetLanguage,
      }),
    });

    if (!response.ok) {
      console.error(`Translation API error: ${response.status}`);
      return text; // Return original text if API fails
    }

    const data = await response.json();
    return data.text || text;
  } catch (error) {
    console.error("Translation service error:", error);
    return text; // Return original text if request fails
  }
}

/**
 * Helper function to translate text from French to English
 */
export async function translateFrToEn(text: string): Promise<string> {
  return translate(text, "fr", "en");
}
